const SCENE_RATIO = [2, 4];

export const DEFAULT_SCENE_RATIO = 2;

export default SCENE_RATIO;
